<div class="blog-post-page">
  <!-- Loading -->
  <div *ngIf="loading" class="loading-state">
    <div class="spinner spinner-lg"></div>
    <p>Loading article...</p>
  </div>

  <!-- Error -->
  <div *ngIf="error && !loading" class="error-state">
    <h2>Article not found</h2>
    <a routerLink="/blog" class="btn btn-primary">Back to blog</a>
  </div>

  <!-- Post -->
  <article *ngIf="!loading && !error && post" class="post">
    <!-- Hero -->
    <header class="post-hero">
      <div class="container container-sm">
        <a routerLink="/blog" class="back-link">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
          Back to blog
        </a>

        <div class="post-meta-top">
          <span class="badge badge-primary" *ngIf="post.category_name">{{ post.category_name }}</span>
          <span class="post-date">{{ post.published_at | date:'MMMM d, yyyy' }}</span>
        </div>

        <h1 class="post-title">{{ post.title }}</h1>
        <p class="post-excerpt">{{ post.excerpt }}</p>

        <div class="post-author">
          <div class="author-avatar">{{ (post.author_name || 'Q').charAt(0) }}</div>
          <div>
            <div class="author-name">{{ post.author_name || 'Quick Indexing' }}</div>
            <div class="author-meta">{{ post.reading_time }} min read</div>
          </div>
        </div>
      </div>
    </header>

    <!-- Featured image -->
    <div class="post-featured-image" *ngIf="post.featured_image?.large">
      <div class="container">
        <img [src]="post.featured_image?.large" [alt]="post.title" />
      </div>
    </div>

    <!-- Content -->
    <div class="post-content">
      <div class="container container-sm">
        <div class="content-body" [innerHTML]="safeContent"></div>

        <!-- Tags -->
        <div class="post-tags" *ngIf="post.tags && post.tags.length > 0">
          <span class="post-tag" *ngFor="let tag of post.tags">#{{ tag }}</span>
        </div>

        <!-- Share -->
        <div class="post-share">
          <span>Share:</span>
          <a [href]="twitterShareUrl()" target="_blank" rel="noopener" class="share-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"/></svg>
            Twitter
          </a>
          <a [href]="linkedinShareUrl()" target="_blank" rel="noopener" class="share-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19a.66.66 0 000 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z"/></svg>
            LinkedIn
          </a>
        </div>
      </div>
    </div>

    <!-- Related posts -->
    <div class="related-posts" *ngIf="relatedPosts && relatedPosts.length > 0">
      <div class="container">
        <h2>Related articles</h2>
        <div class="related-grid">
          <a *ngFor="let rel of relatedPosts" [routerLink]="['/blog', rel.slug]" class="related-card">
            <span class="related-category" *ngIf="rel.category_name">{{ rel.category_name }}</span>
            <h3>{{ rel.title }}</h3>
            <span class="related-date">{{ rel.published_at | date:'MMM d' }}</span>
          </a>
        </div>
      </div>
    </div>
  </article>
</div>
